// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep custom-navbar ion-header ion-toolbar ion-title {
  color: var(--ion-color-light) !important;
  margin: 0;
  font-size: 1.125rem !important;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
  font-weight: 500 !important;
  font-family: var(--font-secondary) !important;
}
::ng-deep custom-navbar ion-header ion-toolbar ion-title b {
  font-family: var(--font-secondary) !important;
  font-weight: bold;
}

@media (max-width: 768px) {
  ::ng-deep .indicators {
    height: 10px;
  }
}

@media (orientation: landscape) {
  ::ng-deep .image-container .promotion-dash {
    margin: 3.75rem 0 0.75rem 1.625rem !important;
  }
}

.content {
  background: var(--ion-color-dark-background);
  position: relative;
  height: 100%;
  overflow: auto;
  padding: 0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
  margin-top: -1px;
}
.content ion-grid {
  height: 100%;
  margin: 0;
  padding: 0rem 0.69rem 0.5rem 0.628rem;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.content ion-grid ion-row {
  gap: 0.813rem 0;
}
.content ion-grid ion-row:not(:last-of-type) {
  margin-bottom: 0.813rem;
}
.content ion-grid ion-row:last-of-type {
  flex: 1;
  display: flex;
  align-items: flex-end;
  padding-bottom: env(safe-area-inset-bottom);
}
.content ion-grid ion-row ion-col {
  padding: 0 0.3125rem;
}
.content ion-grid ion-row ion-col p {
  color: var(--ion-color-light);
  margin: 0;
}
.content ion-grid ion-row ion-col h2 {
  font-family: var(--font-primary);
  color: var(--ion-color-light);
  margin: 0;
  font-size: 2.125rem;
}
.content ion-grid ion-row ion-col h2.overflow-dots {
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
}
.content ion-grid ion-row ion-col .pending-wd {
  font-size: 0.89rem;
  font-weight: 400;
  line-height: 1rem;
  text-align: center;
  color: var(--ion-color-light);
  text-decoration: underline;
  display: block;
}
.content ion-grid ion-row ion-col .cashier {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;
}
.content ion-grid ion-row ion-col .cashier app-deposit-button {
  text-align: center;
  min-width: 18.5rem;
}
.content ion-grid ion-row ion-col ion-checkbox {
  --checkbox-background-checked: var(--player-dashboard-checkbox);
  --checkbox-background:transparent;
  --checkmark-color:var(--ion-color-light);
  --border-radius: 0.125rem;
  --border-color: var(--ion-color-light);
  --border-width: 1px;
  --size: 1.125rem;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer {
  padding: 0.5rem 0.438rem 0 0.75rem;
  margin: 0;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer .my-rewards-top-content .reward-img img {
  width: 5.17rem;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer .my-rewards-top-content .rewards-titles-styes .rewards-title {
  font-size: 1.375rem;
  line-height: 1.61rem;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer .my-rewards-top-content .rewards-titles-styes .rewards-level-label {
  font-size: 0.875rem;
  line-height: 1.03rem;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer ion-range {
  --bar-height: 10px;
  --bar-border-radius: 10px;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer .hide-knob::part(bar) {
  border: 2px solid #0099ff;
  background: white;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer .hide-knob::part(bar-active) {
  height: 8px;
  margin-left: 3px;
  bottom: -1px;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer .range-container span {
  font-size: 0.6875rem;
  line-height: 0.806rem;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer .my-rewards-bottom-content .rp-col .rp-col-label {
  font-size: 1rem;
  line-height: 1.17rem;
}
.content ion-grid ion-row ion-col::ng-deep .my-rewards-maincontainer .my-rewards-bottom-content .rp-col .rp-col-value {
  font-size: 1.375rem;
  line-height: 1.61rem;
}

.ios-checkbox ion-checkbox::part(container) {
  border-radius: 6px;
}

@media screen and (min-width: 992px) {
  .flex-lg-up {
    display: flex;
    flex-direction: column;
  }
}
@media screen and (max-width: 991px) {
  .content ion-grid ion-row {
    gap: 0.5rem 0;
  }
  .content ion-grid ion-row:first-of-type {
    margin-bottom: 0.19rem;
  }
  .content ion-grid ion-row:last-of-type {
    flex: unset;
  }
  .content ion-grid ion-row .pending-wd {
    margin-top: 0;
  }
  .content ion-grid ion-row ion-col h2 {
    font-size: 1.25rem;
  }
  .content ion-grid ion-row ion-col .cashier {
    margin: 1rem 0 0.5rem;
  }
  .content ion-grid ion-row ion-col .cashier app-deposit-button::ng-deep ion-button {
    min-height: 1.6rem;
  }
  .content ion-grid ion-row ion-col .cashier app-deposit-button::ng-deep ion-button::part(native) {
    padding: 8px !important;
  }
}
@media screen and (max-width: 450px) {
  ::ng-deep custom-navbar ion-header ion-toolbar {
    --min-height: 45px;
    padding: 0 !important;
  }
  ::ng-deep custom-navbar ion-header ion-toolbar ion-button {
    margin-top: 0;
    margin-bottom: 0;
  }
  ::ng-deep custom-navbar ion-header ion-toolbar ion-button::part(native) {
    padding: 5px !important;
  }
}
@media screen and (max-width: 380px) {
  .content ion-grid ion-row::ng-deep .my-rewards-maincontainer .my-rewards-top-content {
    display: flex;
    gap: 0.5rem;
    margin-bottom: -0.5rem;
  }
  .content ion-grid ion-row::ng-deep .my-rewards-maincontainer .my-rewards-top-content .reward-img {
    position: relative;
  }
  .content ion-grid ion-row::ng-deep .my-rewards-maincontainer .my-rewards-bottom-content .rp-col-value {
    font-size: 1.1rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/player-dashboard/player-dashboard.component.scss"],"names":[],"mappings":"AAGY;EACI,wCAAA;EACA,SAAA;EACA,8BAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AAFhB;AAIgB;EACI,6CAAA;EACA,iBAAA;AAFpB;;AAUI;EADJ;IAEQ,YAAA;EANN;AACF;;AAUM;EADJ;IAEM,6CAAA;EANN;AACF;;AAQA;EACI,4CAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,2FAAA;EACA,gBAAA;AALJ;AAOI;EACI,YAAA;EACA,SAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AALR;AAOQ;EACI,eAAA;AALZ;AAOY;EACI,uBAAA;AALhB;AAQY;EACI,OAAA;EACA,aAAA;EACA,qBAAA;EACA,2CAAA;AANhB;AASY;EACI,oBAAA;AAPhB;AAQgB;EACI,6BAAA;EACA,SAAA;AANpB;AASgB;EACI,gCAAA;EACA,6BAAA;EACA,SAAA;EACA,mBAAA;AAPpB;AASoB;EACI,uBAAA;EACA,iBAAA;EACA,gBAAA;AAPxB;AAWgB;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,0BAAA;EACA,cAAA;AATpB;AAYgB;EACI,aAAA;EACA,OAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAVpB;AAYoB;EACI,kBAAA;EACA,kBAAA;AAVxB;AAcgB;EACI,+DAAA;EACA,iCAAA;EACA,wCAAA;EACA,yBAAA;EACA,sCAAA;EACA,mBAAA;EACA,gBAAA;AAZpB;AAeoB;EACI,kCAAA;EACA,SAAA;AAbxB;AAgB4B;EACI,cAAA;AAdhC;AAiBgC;EACI,mBAAA;EACA,oBAAA;AAfpC;AAiBgC;EACI,mBAAA;EACA,oBAAA;AAfpC;AAoBwB;EACI,kBAAA;EACA,yBAAA;AAlB5B;AAoBwB;EACI,yBAAA;EACA,iBAAA;AAlB5B;AAoBwB;EACI,WAAA;EACA,gBAAA;EACA,YAAA;AAlB5B;AAsB4B;EACI,oBAAA;EACA,qBAAA;AApBhC;AA0BgC;EACI,eAAA;EACA,oBAAA;AAxBpC;AA0BgC;EACI,mBAAA;EACA,oBAAA;AAxBpC;;AAmCA;EACI,kBAAA;AAhCJ;;AAmCA;EACI;IACI,aAAA;IACA,sBAAA;EAhCN;AACF;AAmCA;EAGY;IACI,aAAA;EAnCd;EAqCc;IACI,sBAAA;EAnClB;EAqCc;IACI,WAAA;EAnClB;EAsCc;IACI,aAAA;EApClB;EAuCkB;IACI,kBAAA;EArCtB;EAwCkB;IACI,qBAAA;EAtCtB;EAyC0B;IACI,kBAAA;EAvC9B;EAyC8B;IACI,uBAAA;EAvClC;AACF;AAiDA;EAGY;IACI,kBAAA;IACA,qBAAA;EAjDd;EAmDc;IACI,aAAA;IACA,gBAAA;EAjDlB;EAmDkB;IACI,uBAAA;EAjDtB;AACF;AAyDA;EAMwB;IACI,aAAA;IACA,WAAA;IACA,sBAAA;EA5D1B;EA8D0B;IACI,kBAAA;EA5D9B;EAgE0B;IACI,4BAAA;EA9D9B;AACF","sourcesContent":["::ng-deep custom-navbar {\r\n    ion-header {\r\n        ion-toolbar {\r\n            ion-title { \r\n                color: var(--ion-color-light) !important;\r\n                margin: 0;\r\n                font-size: 1.125rem !important;\r\n                text-overflow: ellipsis;\r\n                text-wrap: nowrap;\r\n                overflow: hidden;\r\n                font-weight: 500 !important;\r\n                font-family: var(--font-secondary) !important;\r\n\r\n                b {\r\n                    font-family: var(--font-secondary)!important;\r\n                    font-weight: bold;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n::ng-deep .indicators {\r\n    @media (max-width: 768px) {\r\n        height: 10px;\r\n    }\r\n}\r\n\r\n  ::ng-deep .image-container .promotion-dash {\r\n      @media (orientation: landscape) {\r\n        margin: 3.75rem 0 0.75rem 1.625rem !important;\r\n      }\r\n  }\r\n.content {\r\n    background: var(--ion-color-dark-background);\r\n    position: relative;\r\n    height: 100%;\r\n    overflow: auto;\r\n    padding: 0 env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);\r\n    margin-top: -1px;\r\n    \r\n    ion-grid {\r\n        height: 100%;\r\n        margin: 0;\r\n        padding: 0rem 0.69rem 0.5rem 0.628rem;\r\n        display: flex;\r\n        flex-direction: column;\r\n        width: 100%;\r\n\r\n        ion-row {\r\n            gap: 0.813rem 0;\r\n\r\n            &:not(:last-of-type) {\r\n                margin-bottom: 0.813rem;\r\n            }\r\n\r\n            &:last-of-type {\r\n                flex: 1;\r\n                display: flex;\r\n                align-items: flex-end;\r\n                padding-bottom: env(safe-area-inset-bottom);\r\n            }\r\n\r\n            ion-col {\r\n                padding: 0 0.3125rem;\r\n                p {\r\n                    color: var(--ion-color-light);\r\n                    margin: 0;\r\n                }\r\n\r\n                h2 {\r\n                    font-family: var(--font-primary);\r\n                    color: var(--ion-color-light);\r\n                    margin: 0;\r\n                    font-size: 2.125rem;\r\n\r\n                    &.overflow-dots {\r\n                        text-overflow: ellipsis;\r\n                        text-wrap: nowrap;\r\n                        overflow: hidden;\r\n                    }\r\n                }\r\n\r\n                .pending-wd {\r\n                    font-size: 0.89rem;\r\n                    font-weight: 400;\r\n                    line-height: 1rem;\r\n                    text-align: center;\r\n                    color: var(--ion-color-light);\r\n                    text-decoration: underline;\r\n                    display: block;\r\n                }\r\n\r\n                .cashier {\r\n                    display: flex;\r\n                    flex: 1;\r\n                    align-items: center;\r\n                    justify-content: center;\r\n                    margin: 1rem 0;\r\n\r\n                    app-deposit-button {\r\n                        text-align: center;\r\n                        min-width: 18.5rem;\r\n                    }\r\n                }\r\n\r\n                ion-checkbox {\r\n                    --checkbox-background-checked: var(--player-dashboard-checkbox);\r\n                    --checkbox-background:transparent;\r\n                    --checkmark-color:var(--ion-color-light);\r\n                    --border-radius: 0.125rem;\r\n                    --border-color:  var(--ion-color-light);\r\n                    --border-width: 1px;\r\n                    --size: 1.125rem;\r\n                }\r\n                &::ng-deep {\r\n                    .my-rewards-maincontainer {\r\n                        padding: 0.5rem 0.438rem 0 0.75rem;\r\n                        margin: 0;\r\n\r\n                        .my-rewards-top-content {\r\n                            .reward-img img {\r\n                                width: 5.17rem;\r\n                            }\r\n                            .rewards-titles-styes {\r\n                                .rewards-title {\r\n                                    font-size: 1.375rem;\r\n                                    line-height: 1.61rem;\r\n                                }\r\n                                .rewards-level-label {\r\n                                    font-size: 0.875rem;\r\n                                    line-height: 1.03rem;\r\n                                }\r\n                            }\r\n                        } \r\n\r\n                        ion-range {\r\n                            --bar-height: 10px;\r\n                            --bar-border-radius: 10px;\r\n                        }\r\n                        .hide-knob::part(bar) {\r\n                            border: 2px solid #0099ff;\r\n                            background: white\r\n                        }\r\n                        .hide-knob::part(bar-active) {\r\n                            height: 8px;\r\n                            margin-left: 3px;\r\n                            bottom: -1px;\r\n                        }\r\n\r\n                        .range-container {\r\n                            span {\r\n                                font-size: 0.6875rem;\r\n                                line-height: 0.806rem;\r\n                            }\r\n                        }\r\n\r\n                        .my-rewards-bottom-content {\r\n                            .rp-col {\r\n                                .rp-col-label {\r\n                                    font-size: 1rem;\r\n                                    line-height: 1.17rem;\r\n                                }\r\n                                .rp-col-value {\r\n                                    font-size: 1.375rem;\r\n                                    line-height: 1.61rem;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.ios-checkbox ion-checkbox::part(container) {\r\n    border-radius: 6px;\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n    .flex-lg-up {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 991px) {\r\n    .content {        \r\n        ion-grid {\r\n            ion-row {\r\n                gap: 0.5rem 0;\r\n        \r\n                &:first-of-type {\r\n                    margin-bottom: 0.19rem;\r\n                }\r\n                &:last-of-type {\r\n                    flex: unset;\r\n                }\r\n        \r\n                .pending-wd {\r\n                    margin-top: 0;\r\n                }\r\n                ion-col {\r\n                    h2 {\r\n                        font-size: 1.25rem;\r\n                    }\r\n\r\n                    .cashier {\r\n                        margin: 1rem 0 0.5rem;\r\n\r\n                        app-deposit-button::ng-deep {\r\n                            ion-button {\r\n                                min-height: 1.6rem;\r\n\r\n                                &::part(native) {\r\n                                    padding: 8px !important;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 450px) {\r\n    ::ng-deep custom-navbar {\r\n        ion-header {\r\n            ion-toolbar {\r\n                --min-height: 45px;\r\n                padding: 0 !important;\r\n\r\n                ion-button{\r\n                    margin-top: 0;\r\n                    margin-bottom: 0;\r\n                    \r\n                    &::part(native) {\r\n                        padding: 5px !important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n}\r\n\r\n@media screen and (max-width: 380px) {\r\n    .content {        \r\n        ion-grid {\r\n            ion-row {\r\n                &::ng-deep {\r\n                    .my-rewards-maincontainer {\r\n                        .my-rewards-top-content {\r\n                            display: flex;\r\n                            gap: 0.5rem;\r\n                            margin-bottom: -0.5rem;\r\n\r\n                            .reward-img {\r\n                                position: relative;\r\n                            }\r\n                        }\r\n                        .my-rewards-bottom-content {\r\n                            .rp-col-value {\r\n                                font-size: 1.1rem !important;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
